<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "BlogMobile"
}
</script>

<style scoped>

</style>